import React, { Component } from 'react'
import Dico from './Dico';

class MessageI18N extends Component {

	render() {
		if (this.props.context == null) {
			return null;
		}
		var actualLanguage = this.props.actualLanguage == null ? this.props.context.languageCode : this.props.actualLanguage;
		var message = Dico.getMessage(
			this.props.context.countryCode,
			actualLanguage,
			this.props.i18n,
			this.props.arg,
			this.props.argType,
			this.props.context.languageCode
		);

		if (this.props.prefix != null) {
			message = this.props.prefix + message;
		}
		if (this.props.removeI18NPrefix) {
			let message1 = message;
			message1 = message1.replace('\\.', '##');

			const n = message1.lastIndexOf('.');
			let value = message1.substring(n + 1);
			value = value.replace('##', '.');
			message = message.replace(this.props.i18n, value);
		}
		if(this.props.callBackText != null){
			this.props.callBackText(message);
		}
		if (this.props.optionValue != null) {
			return <option value={this.props.optionValue} style={this.props.optionStyle}>{message}</option>
		} else {
			return (
				<React.Fragment>{message}</React.Fragment>
			)
		}
	}
}


export default MessageI18N

